/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { func, object } from 'prop-types';
import ReactMarkdown from 'react-markdown';

import {
    FormControl, FormControlLabel, Grid, Radio, RadioGroup,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { convertDateObjToStrDate } from '../../helpers/Calendar-Helper';
import { trackEvent } from '../../../../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import { sanitizeContent } from '../../../../../../../../../lib/sanitize';
import { calendarColorStyle } from '../../../Helpers/Style-Helper';

const useStyles = makeStyles(
    (theme) => ({
        windowContent: {
            fontSize: '14px !important',
            fontWeight: '400',
            padding: '0 0 8px',
        },
        radioButtonColor: {
            color: calendarColorStyle.primary?.main,
            padding: '2px 10px',

        },
        hideBtn: {
            display: 'none',
        },
        windowContentPadding: {
            paddingLeft: 0,
        },
        flexContent: {
            width: '100%',
        },
        title: {
            fontSize: '1em',
            fontWeight: '700',
            textAlign: 'center',
            padding: '0 0 8px',
            margin: 0,
            lineHeight: '1.313em',
        },
        label: {
            margin: 0,
            alignItems: 'flex-start',
        },
        labelSingleOption: {
            textAlign: 'center',
        },
        flexOptionContainer: {
            width: '100%',
        },
        flexImage: {
            textAlign: 'center',
            display: 'block',
            margin: '0 auto',
            width: 'auto',
            height: '18px',
        },
    }),
    { name: 'FlexOptions' },
);

const FlexOptions = ({
    cmsData,
    flexOptionSelected,
    flexDetails,
    orderItem,
    selectedDeliveryDateObj,
    setFlexOptionSelected,
}) => {
    const dispatchAction = useDispatch();
    const classes = useStyles();

    const flexData = flexDetails.option || [];
    const flexImage = cmsData?.entries?.[0]?.flex_banner_head_image || {};

    const handleDateChange = (e) => {
        // The whole flex date object needs to be stored in state.
        const flexSelected = flexData.find((flexDay) => flexDay.optionCode === e.target.value);
        setFlexOptionSelected(flexSelected);
    };

    useEffect(() => {
        if (!flexOptionSelected?.optionKey) {
            let flexSelectedByCalendar = flexDetails.option.find((flexDate) => flexDate?.defaultOption === 'Y') || null;
            const deliveryDateFromCart = new Date(orderItem.deliveryInfo.deliveryDate);
            const deliveryDateFromCartStr = convertDateObjToStrDate(deliveryDateFromCart);
            if (orderItem.selectedFlexOption?.optionCode && selectedDeliveryDateObj.deliveryDate === deliveryDateFromCartStr) {
                flexSelectedByCalendar = selectedDeliveryDateObj.flexDetails.option.find((flexDate) => flexDate?.optionCode === orderItem.selectedFlexOption.optionCode) || null;
            }

            if (flexSelectedByCalendar) {
                setFlexOptionSelected(flexSelectedByCalendar);
            }
        }
        dispatchAction(
            trackEvent({
                eventName: 'feature_interaction',
                eventCategory: 'Checkout',
                eventAction: 'Enterprise Calendar Flex Options',
                eventLavel: 'Impression',
            }),
        );
    }, []);

    if (!flexOptionSelected?.optionCode) {
        return null;
    }

    return (
        <Grid container direction="column">
            <Grid item xs={12}>
                <p id="title" className={classes.title}>
                    {flexImage?.url && (
                        <img src={flexImage.url} alt={flexImage.title} className={classes.flexImage} />
                    )}
                    {sanitizeContent(flexData[0].flexMsg?.find((message) => message.msgType === '7')?.msgText, { USE_PROFILES: { html: false } })}
                </p>
            </Grid>
            <Grid item xs={12} className={classes.flexContent}>
                <FormControl component="fieldset" className={classes.flexOptionContainer}>
                    <RadioGroup name="flexSelect" value={flexOptionSelected.optionCode} onChange={handleDateChange}>
                        {flexData.map((flexDay) => (
                            <FormControlLabel
                                value={flexDay.optionCode}
                                className={`${classes.label} ${flexData.length === 1 && classes.labelSingleOption}`}
                                control={<Radio classes={{ root: flexData.length === 1 ? classes.hideBtn : `${classes.radioButtonColor}`, checked: classes.checked }} />}
                                label={(
                                    <ReactMarkdown
                                        className={`${flexData.length === 1 && classes.windowContentPadding} ${classes.windowContent}`}
                                        escapeHtml={false}
                                        source={flexDay.flexMsg?.find((message) => message.msgTypeLocation === 'Product')?.msgText}
                                    />
                                )}
                                key={flexDay.optionCode}
                            />
                        ))}
                    </RadioGroup>
                </FormControl>
            </Grid>
        </Grid>
    );
};

FlexOptions.propTypes = {
    cmsData: object.isRequired,
    flexOptionSelected: object.isRequired,
    flexDetails: object.isRequired,
    orderItem: object.isRequired,
    selectedDeliveryDateObj: object.isRequired,
    setFlexOptionSelected: func.isRequired,
};

export default FlexOptions;
